import { gcloudStorageApi } from 'lib/api/client'
import { BuildMetricsRecord } from './buildMetrics.types'

export const getBuildMetrics = async (
  app: string
): Promise<Array<BuildMetricsRecord>> => {
  const { data } = await gcloudStorageApi.get<Array<BuildMetricsRecord>>(
    '/build-metrics',
    { params: { app } }
  )

  return data
}
